import AsyncStorage from "@react-native-async-storage/async-storage";
import { configureStore } from "@reduxjs/toolkit";
import { persistCombineReducers } from "redux-persist";
import { createStateSyncMiddleware } from "redux-state-sync";
import activeTestSessionsSlice from "../../features/activeTestSessions/activeTestSessionsSlice";
import subjectFlashcardsSlice from "../../features/flashcards/subjectFlashcardsSlice";
import CustomTestUserReduxMetadataSlice from "../../features/progress/customTestUserReduxMetadataSlice";
import MockExamUserReduxMetadataSlice from "../../features/progress/mockExamUserReduxMetadataSlice";
import SubtopicUserReduxMetadataSlice from "../../features/progress/subTopicUserReduxMetadataSlice";
import TopicTestUserReduxMetadataSlice from "../../features/progress/topicTestUserReduxMetadataSlice";
import subjectSyllabusChecklistSlice from "../../features/syllabus/subjectSyllabusChecklistSlice";

const persistConfig = {
  key: "root",
  version: 1,
  storage: AsyncStorage,
};

const reducer = {
  activeTestSessions: activeTestSessionsSlice,
  CustomTestUserReduxMetadata: CustomTestUserReduxMetadataSlice,
  MockExamUserReduxMetadata: MockExamUserReduxMetadataSlice,
  TopicTestUserReduxMetadata: TopicTestUserReduxMetadataSlice,
  SubtopicUserReduxMetadata: SubtopicUserReduxMetadataSlice,
  subjectSyllabus: subjectSyllabusChecklistSlice,
  subjectFlashcards: subjectFlashcardsSlice,
};

const persistedReducer = persistCombineReducers(persistConfig, reducer);

export function initializeSSRStore() {
  const isServer = typeof window === "undefined";
  let store;
  if (isServer) {
    store = configureStore({
      reducer,
      middleware: [],
    });
  } else {
    store = configureStore({
      reducer: persistedReducer,
      middleware: [
        createStateSyncMiddleware({
          blacklist: ["persist/PERSIST", "persist/REHYDRATE"],
        }),
      ],
    });
  }
  return store;
}
